import { useAtomValue } from 'jotai'
import React from 'react'
import { match } from 'ts-pattern'

import { dialogInfoAtom } from '../atoms'

import { AddBrandUserDialog } from './AddBrandUserDialog'
import { DeleteBrandUserDialog } from './DeleteBrandUserDialog'
import { EditBrandUserDialog } from './EditBrandUserDialog'

export const Dialogs = () => {
  const dialogInfo = useAtomValue(dialogInfoAtom)

  return match(dialogInfo?.dialogType)
    .with(undefined, () => null)
    .with('delete', () => <DeleteBrandUserDialog />)
    .with('edit', () => <EditBrandUserDialog />)
    .with('add', () => <AddBrandUserDialog />)
    .exhaustive()
}
